import { render, staticRenderFns } from "./CategoryItemsBestSeller.vue?vue&type=template&id=3097fbcb&scoped=true"
import script from "./CategoryItemsBestSeller.vue?vue&type=script&lang=js"
export * from "./CategoryItemsBestSeller.vue?vue&type=script&lang=js"
import style0 from "./CategoryItemsBestSeller.vue?vue&type=style&index=0&id=3097fbcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097fbcb",
  null
  
)

export default component.exports